<template>
  <div>
    <!-- 顶部快捷导航 开始 -->
    <div class="shortcut">
      <div class="w">
        <div class="fl">
          <ul>
            <li><a href="#" class="style-red">三发集团</a>欢迎您！</li>
            <li><a href="#">济南</a></li>
          </ul>
        </div>
        <div class="fr">
          <ul>
            <li>
              <!-- <a href="#">网站导航</a> -->
              打造三发地产品牌，实现多元化经营集团化发展。
            </li>
            <!-- <li class="spacer"></li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 顶部快捷导航 结束 -->

    <!-- header区域 开始 -->
    <div class="header">
      <!-- <img src="img/logo_header.png" alt=""> -->
      <div class="w daohang">
        <div class="logo fl">
          <h1>
            <a href="#" title="三发集团">三发集团</a>
          </h1>
        </div>
        <div class="nav fr">
          <ul>
            <li>
              <router-link
                to="/"
                :class="{ active: this.$route.name == 'home' }"
                >首页</router-link
              >
            </li>
            <li>
              <router-link
                to="/about"
                :class="{
                  active:
                    this.$route.name == 'licheng' ||
                    this.$route.name == 'rongyu' ||
                    this.$route.name == 'wenhua' ||
                    this.$route.name == 'chuangshiren' ||
                    this.$route.name == 'gaikuang',
                }"
                >关于我们</router-link
              >
            </li>
            <li>
              <router-link
                to="/list"
                :class="{ active: this.$route.name == 'list' }"
                >三发资讯</router-link
              >
            </li>
            <li>
              <router-link
                to="/project"
                :class="{ active: this.$route.name == 'project' }"
                >公司项目</router-link
              >
            </li>
            <li>
              <router-link
                to="/party"
                :class="{
                  active:
                    this.$route.name == 'dongtai' ||
                    this.$route.name == 'news' ||
                    this.$route.name == 'study' ||
                    this.$route.name == 'jianshe',
                }"
                >党建引领</router-link
              >
            </li>
            <li>
              <router-link
                to="/join"
                :class="{ active: this.$route.name == 'join' }"
                >加入三发</router-link
              >
            </li>
            <li>
              <router-link
                to="/contact"
                :class="{ active: this.$route.name == 'contact' }"
                >联络三发</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="w drop-down">

        </div> -->
    </div>
    <!-- header区域 结束 -->
  </div>
</template>
<script>
export default {
  name: "HomeHeader",
};
</script>
